import { EnumDataType } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { EnumPersistenceStatus } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { DiagramShape } from '@/api/com/MetaPattern/MDA/Designer/Shape/DiagramShape';
import { ShapeElement } from '@/api/com/MetaPattern/MDA/Designer/Shape/ShapeElement';
import { ShapeService } from '@/api/com/MetaPattern/MDA/Designer/Shape/ShapeService';
import { APPComment } from '@/api/com/MetaPattern/MDA/MD/APPModel/APPComment';
import { APPComponent } from '@/api/com/MetaPattern/MDA/MD/APPModel/APPComponent';
import { ConfigGroup } from '@/api/com/MetaPattern/MDA/MD/APPModel/ConfigGroup';
import { ConfigItem } from '@/api/com/MetaPattern/MDA/MD/APPModel/ConfigItem';
import { MenuItem } from '@/api/com/MetaPattern/MDA/MD/APPModel/MenuItem';
import { MenuSet } from '@/api/com/MetaPattern/MDA/MD/APPModel/MenuSet';
import { APP } from '@/api/com/MetaPattern/MDA/MD/Base/APP';
import { BaseComponent } from '@/api/com/MetaPattern/MDA/MD/Base/BaseComponent';
import { BaseElement } from '@/api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { BaseService } from '@/api/com/MetaPattern/MDA/MD/Base/BaseService';
import { EnumComponentType } from '@/api/com/MetaPattern/MDA/MD/Base/EnumComponentType';
import { Product } from '@/api/com/MetaPattern/MDA/MD/Base/Product';
import { BaseAttribute } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BaseAttribute';
import { BaseMethod } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BaseMethod';
import { BEAttribute } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEAttribute';
import { BEBusinessLogic } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEBusinessLogic';
import { BEComment } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEComment';
import { BEComponent } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEComponent';
import { BEConstant } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEConstant';
import { BEDistributedTransaction } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEDistributedTransaction';
import { BEDTO } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEDTO';
import { BEEntity } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEEntity';
import { BEEnum } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEEnum';
import { BEExternalService } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEExternalService';
import { BEInterface } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEInterface';
import { BEService } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEService';
import { BEServiceAction } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEServiceAction';
import { BEValueObject } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEValueObject';
import { CompleteAttribute } from '@/api/com/MetaPattern/MDA/MD/EntityModel/CompleteAttribute';
import { DTAttribute } from '@/api/com/MetaPattern/MDA/MD/EntityModel/DTAttribute';
import { EnumBEType } from '@/api/com/MetaPattern/MDA/MD/EntityModel/EnumBEType';
import { EnumEntityStructureType } from '@/api/com/MetaPattern/MDA/MD/EntityModel/EnumEntityStructureType';
import { EnumServiceActionType } from '@/api/com/MetaPattern/MDA/MD/EntityModel/EnumServiceActionType';
import { MDParameter } from '@/api/com/MetaPattern/MDA/MD/EntityModel/MDParameter';
import { MDService } from '@/api/com/MetaPattern/MDA/MD/EntityModel/MDService';
import { ProductAPP } from '@/api/com/MetaPattern/MDA/MD/ProductModel/ProductAPP';
import { ProductComment } from '@/api/com/MetaPattern/MDA/MD/ProductModel/ProductComment';
import { ProductComponent } from '@/api/com/MetaPattern/MDA/MD/ProductModel/ProductComponent';
import { EVOAction } from '@/api/com/MetaPattern/MDA/MD/UIModel/EVOAction';
import { EVOAttribute } from '@/api/com/MetaPattern/MDA/MD/UIModel/EVOAttribute';
import { UIModelComponent } from '@/api/com/MetaPattern/MDA/MD/UIModel/UIModelComponent';
import { UIPage } from '@/api/com/MetaPattern/MDA/MD/UIModel/UIPage';
import { UIPageGroup } from '@/api/com/MetaPattern/MDA/MD/UIModel/UIPageGroup';
import { UIView } from '@/api/com/MetaPattern/MDA/MD/UIModel/UIView';
import { ViewObject } from '@/api/com/MetaPattern/MDA/MD/UIModel/ViewObject';
import { IDEContext } from '../../Product/IDE/IDEContext';
import { IDEProgram } from '../../Product/IDE/IDEProgram';
import { GuidHelper } from '../../Product/IDE/Util/GuidHelper';
import { TreeNode } from '../../Product/IDE/Util/TreeNode';
import { PGContext } from './PGContext';
import { UniqueKeyManager } from './UniqueKeyManager';
/**
 * 元数据服务 服务类
 * 定义元数据相关服务
 */
export class MDExtendService {
  static async GetAPPTreeAsync(appKey: string): Promise<Array<APP> | null> {
    return new Promise((resolve, reject) => {
      MDService.GetAllAPPAsync(appKey)
        .then((response: Array<APP>) => {
          if (response) {
            response.forEach((app: APP) => {
              app.aPPComponents.forEach(appComponent => { appComponent.aPP = app; });
              app.bEComponents.forEach(be => { be.aPP = app; });
              app.dBComponents.forEach(db => { db.aPP = app; });
              app.uIModelComponents.forEach(uiModel => { uiModel.aPP = app; });
            });
          }
          resolve(response);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetInfrastructureAPPTreeAsync(): Promise<APP | null> {
    return new Promise((resolve, reject) => {
      MDService.GetInfrastructureAPPAsync()
        .then((app: APP) => {
          if (app) {
            app.aPPComponents.forEach(appComponent => { appComponent.aPP = app; });
            app.bEComponents.forEach(be => { be.aPP = app; });
            app.dBComponents.forEach(db => { db.aPP = app; });
            app.uIModelComponents.forEach(uiModel => { uiModel.aPP = app; });
          }
          resolve(app);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetProductTreeAsync(): Promise<Array<Product> | null> {
    return new Promise((resolve, reject) => {
      BaseService.GetAllProductAsync()
        .then((response: Array<Product>) => {
          resolve(response);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  /**
   * 根据组件类型，查询组件ID对应的组件详情
   * @param componentId 组件ID
   * @param componentType 组件类型
   * @returns 服务端的组件详情
   */
  static async GetFullComponentAsync(componentId: string, componentType: EnumComponentType): Promise<BaseComponent | null> {
    if (componentType === EnumComponentType.BE) {
      return new Promise((resolve, reject) => {
        MDService.GetFullBEComponentAsync(componentId)
          .then((component: BEComponent) => {
            // 构建正确的引用关系
            component.aggregations.forEach(aggregation => {
              aggregation.component = component;
              aggregation.sourceEntity = component.entities.find(entity => entity.id === aggregation.sourceEntity_ID);
              aggregation.sourceEntity.sourceAggregations.push(aggregation);
              aggregation.targetEntity = component.entities.find(entity => entity.id === aggregation.targetEntity_ID);
              aggregation.targetEntity.targetAggregations.push(aggregation);
            });
            component.associations.forEach(association => {
              association.component = component;
              association.sourceEntity = component.entities.find(entity => entity.id === association.sourceEntity_ID);
              association.sourceEntity.sourceAssociations.push(association);
              association.targetEntity = component.entities.find(entity => entity.id === association.targetEntity_ID);
              association.targetEntity.targetAssociations.push(association);
            });
            component.businessLogics.forEach(businessLogic => {
              businessLogic.component = component;
              businessLogic.parameters.forEach(parameter => { parameter.businessLogic = businessLogic; });
            });
            component.comments.forEach(comment => { comment.component = component; });
            component.compositions.forEach(composition => {
              composition.component = component;
              composition.sourceEntity = component.entities.find(entity => entity.id === composition.sourceEntity_ID);
              composition.sourceEntity.sourceCompositions.push(composition);
              composition.targetEntity = component.entities.find(entity => entity.id === composition.targetEntity_ID);
              composition.targetEntity.targetCompositions.push(composition);
            });
            component.constants.forEach(constant => {
              constant.component = component;
              constant.items.forEach(item => { item.constant = constant; });
            });
            component.crossAssociations.forEach(crossAssociation => {
              crossAssociation.component = component;
              crossAssociation.sourceEntity = component.entities.find(entity => entity.id === crossAssociation.sourceEntity_ID);
              crossAssociation.sourceEntity.sourceCrossAssociations.push(crossAssociation);
              crossAssociation.targetEntity = component.entities.find(entity => entity.id === crossAssociation.targetEntity_ID);
              crossAssociation.targetEntity.targetCrossAssociations.push(crossAssociation);
            });
            component.dTOes.forEach(dTO => {
              dTO.component = component;
              dTO.attributes.forEach(item => { item.dTO = dTO; });
            });
            component.dependencyAssociations.forEach(dependencyAssociation => {
              dependencyAssociation.component = component;
              dependencyAssociation.sourceEntity = component.entities.find(entity => entity.id === dependencyAssociation.sourceEntity_ID);
              dependencyAssociation.sourceEntity.sourceDependencyAssociations.push(dependencyAssociation);
              dependencyAssociation.targetEntity = component.entities.find(entity => entity.id === dependencyAssociation.targetEntity_ID);
              dependencyAssociation.targetEntity.targetDependencyAssociations.push(dependencyAssociation);
            });
            component.distributedTransactions.forEach(distributedTransaction => {
              distributedTransaction.component = component;
              distributedTransaction.attributes.forEach(attribute => { attribute.distributedTransaction = distributedTransaction; });
            });
            component.entities.forEach(entity => {
              entity.component = component;
              entity.attributes.forEach(attribute => { attribute.entity = entity; });
              entity.methods.forEach(method => {
                method.entity = entity;
                method.parameters.forEach(parameter => { parameter.entityMethod = method; });
              });
            });
            component.entityGenerations.forEach(entityGeneration => {
              entityGeneration.component = component;
              entityGeneration.superEntity = component.entities.find(entity => entity.id === entityGeneration.superEntity_ID);
              entityGeneration.superEntity.superGenerations.push(entityGeneration);
              entityGeneration.subEntity = component.entities.find(entity => entity.id === entityGeneration.subEntity_ID);
              entityGeneration.subEntity.subGenerations.push(entityGeneration);
              entityGeneration.subEntity.superEntity = entityGeneration.superEntity;
            });
            component.enums.forEach(enumItem => {
              enumItem.component = component;
              enumItem.enumItems.forEach(item => { item.enum = enumItem; });
            });
            component.exceptions.forEach(exception => { exception.component = component; });
            component.externalServices.forEach(externalService => {
              externalService.component = component;
              externalService.parameters.forEach(parameter => { parameter.externalService = externalService; });
            });
            component.implements.forEach(implement => {
              implement.component = component;
              implement.entity = component.entities.find(entity => entity.id === implement.entity_ID);
              implement.entity.implements.push(implement);
              implement.interface = component.interfaces.find(element => element.id === implement.interface_ID);
              implement.interface.implements.push(implement);
            });
            component.importNamespaces.forEach(importNamespace => { importNamespace.component = component; });
            component.interfaceGenerations.forEach(interfaceGeneration => {
              interfaceGeneration.component = component;
              interfaceGeneration.superInterface = component.interfaces.find(element => element.id === interfaceGeneration.superInterface_ID);
              interfaceGeneration.superInterface.superGenerations.push(interfaceGeneration);
              interfaceGeneration.subInterface = component.interfaces.find(element => element.id === interfaceGeneration.subInterface_ID);
              interfaceGeneration.subInterface.subGenerations.push(interfaceGeneration);
            });
            component.interfaces.forEach(element => {
              element.component = component;
              element.attributes.forEach(attribute => { attribute.interface = element; });
              element.methods.forEach(method => {
                method.interface = element;
                method.parameters.forEach(parameter => { parameter.interfaceMethod = method; });
              });
            });
            component.referCrossAssociations.forEach(referCrossAssociation => {
              referCrossAssociation.component = component;
              referCrossAssociation.sourceEntity = component.entities.find(entity => entity.id === referCrossAssociation.sourceEntity_ID);
              referCrossAssociation.sourceEntity.sourceReferCrossAssociations.push(referCrossAssociation);
              referCrossAssociation.targetReferenceEntity = component.referenceEntities.find(entity => entity.id === referCrossAssociation.targetReferenceEntity_ID);
              referCrossAssociation.targetReferenceEntity.targetReferCrossAssociations.push(referCrossAssociation);
            });
            component.referenceEntities.forEach(referenceEntity => {
              referenceEntity.component = component;
              if (referenceEntity.entity_ID !== null) {
                referenceEntity.entity = BEEntity.Create(referenceEntity.json.Entity);
                referenceEntity.entity.component = BEComponent.Create(referenceEntity.entity.json.Component);
              }
            });
            component.services.forEach(service => {
              service.component = component;
              service.serviceActions.forEach(serviceAction => {
                serviceAction.service = service;
                if (serviceAction.serviceActionType === EnumServiceActionType.BusinessLogic && serviceAction.businessLogic_ID !== null) {
                  serviceAction.businessLogic = component.businessLogics.find(businessLogic => businessLogic.id === serviceAction.businessLogic_ID);
                } else if (serviceAction.serviceActionType === EnumServiceActionType.API && serviceAction.externalService_ID !== null) {
                  serviceAction.externalService = component.externalServices.find(externalService => externalService.id === serviceAction.externalService_ID);
                }
              });
            });
            component.valueObjects.forEach(valueObject => {
              valueObject.component = component;
              valueObject.attributes.forEach(attribute => { attribute.valueObject = valueObject; });
              valueObject.methods.forEach(method => {
                method.valueObject = valueObject;
                method.parameters.forEach(parameter => { parameter.valueObjectMethod = method; });
              });
            });
            resolve(component as BaseComponent);
          })
          .catch(error => {
            // TODO : 格式化错误返回
            reject(error);
          });
      });
    } else if (componentType === EnumComponentType.APP) {
      return new Promise((resolve, reject) => {
        MDService.GetFullAPPComponentAsync(componentId)
          .then((component: APPComponent) => {
            component.comments.forEach(comment => { comment.component = component; });
            component.configGroups.forEach(configGroup => {
              configGroup.component = component;
              configGroup.configItems.forEach(configItem => { configItem.configGroup = configGroup; });
            });
            component.dependencies.forEach(dependency => { dependency.component = component; });
            component.menuContains.forEach(menuContain => {
              menuContain.aPPComponent = component;
              menuContain.mainMenuSet = component.menuSets.find(menuSet => menuSet.id === menuContain.mainMenuSet_ID);
              menuContain.mainMenuSet.mainMenuContains.push(menuContain);
              menuContain.subMenuSet = component.menuSets.find(menuSet => menuSet.id === menuContain.subMenuSet_ID);
              menuContain.subMenuSet.subMenuContains.push(menuContain);
            });
            component.menuSets.forEach(menuSet => {
              menuSet.component = component;
              menuSet.menuItems.forEach(menuItem => {
                menuItem.menuSet = menuSet;
                if (menuItem.page_ID !== null) {
                  menuItem.page = UIPage.Create(menuItem.json.Page);
                }
              });
            });
            component.taskSequences.forEach(taskSequence => {
              taskSequence.aPPComponent = component;
              taskSequence.beforeTask = component.tasks.find(task => task.id === taskSequence.beforeTask_ID);
              taskSequence.beforeTask.beforeTaskSequences.push(taskSequence);
              taskSequence.afterTask = component.tasks.find(task => task.id === taskSequence.afterTask_ID);
              taskSequence.afterTask.afterTaskSequences.push(taskSequence);
            });
            component.tasks.forEach(task => { task.component = component; });
            resolve(component as BaseComponent);
          })
          .catch(error => {
            // TODO : 格式化错误返回
            reject(error);
          });
      });
    } else if (componentType === EnumComponentType.Product) {
      return new Promise((resolve, reject) => {
        BaseService.GetFullProductComponentAsync(componentId)
          .then((response: ProductComponent) => {
            if (response) {
              response.comments.forEach(comment => { comment.component = response; });
              response.productAPPs.forEach(productAPP => {
                productAPP.component = response;
                if (productAPP.aPP_ID !== null) {
                  const find = response.json.ProductAPPs.find((item: any) => item.APP_ID === productAPP.aPP_ID);
                  if (find) {
                    productAPP.aPP = APP.Create(find.APP);
                  }
                }
              });
            }
            resolve(response);
          })
          .catch(error => {
            // TODO : 格式化错误返回
            reject(error);
          });
      });
    } else if (componentType === EnumComponentType.UIModel) {
      return new Promise((resolve, reject) => {
        MDService.GetFullUIModelComponentAsync(componentId)
          .then((component: UIModelComponent) => {
            if (component) {
              component.viewObjects.forEach(viewObject => {
                viewObject.component = component;
                if (viewObject.bindingBEEntity_ID !== '') {
                  viewObject.bindingBEEntity = BEEntity.Create(viewObject.json.BindingBEEntity);
                }
                viewObject.attributes.forEach(attribute => {
                  attribute.viewObject = viewObject;
                  if (attribute.bindingBEAttribute_ID !== '') {
                    attribute.bindingBEAttribute = BEAttribute.Create(attribute.json.BindingBEAttribute);
                  }
                });
                viewObject.actions.forEach(action => {
                  action.viewObject = viewObject;
                  if (action.actionType_ID !== '') {
                    const actionTypes = IDEProgram.instance.getActionTypes();
                    if (actionTypes) {
                      const actionType = actionTypes.find(item => item.id === action.actionType_ID);
                      if (actionType) {
                        action.actionType = actionType;
                      }
                    }
                  }
                });
              });
              component.pageGroups.forEach(pageGroup => {
                pageGroup.component = component;
                pageGroup.pages.forEach(page => {
                  page.pageGroup = pageGroup;
                  component.pageViews.forEach(item => {
                    if (item.page_ID === page.id) {
                      item.page = page;
                      // page.pageViews.push(item);
                    }
                  });
                });
              });
              component.pageViews.forEach(pageView => {
                pageView.component = component;
                const findView = component.views.find(item => item.id === pageView.view_ID);
                pageView.view = findView;
                // findView.pageViews.push(pageView);
              });
              component.views.forEach(view => {
                view.component = component;
                const findViewObject = component.viewObjects.find(viewObject => viewObject.id === view.viewObject_ID);
                view.viewObject = findViewObject;
                // findViewObject.views.push(view);
              });
            }
            resolve(component);
          })
          .catch(error => {
            // TODO : 格式化错误返回
            reject(error);
          });
      });
    }
    return new Promise((resolve) => resolve(null));
  }

  /**
   * 保存组件图形
   * @param diagramShape 图形
   */
  static async SaveDiagramAsync(diagramShape: DiagramShape): Promise<boolean> {
    return new Promise((resolve, reject) => {
      ShapeService.SaveDiagramAsync(diagramShape)
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
            diagramShape.persistenceStatus = EnumPersistenceStatus.None;
            this.handlePersistentStatus(diagramShape.nodeShapes);
            this.handlePersistentStatus(diagramShape.lineShapes);
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  /**
   * 根据组件类型，保存组件详情
   * @param componentId 组件ID
   * @param componentType 组件类型
   * @returns 是否保存成功
   */
  static async SaveComponentAsync(component: BaseComponent, deleteDesignIds: Array<string>): Promise<boolean> {
    if (component.componentType === EnumComponentType.BE) {
      return new Promise((resolve, reject) => {
        // 构建正确的引用关系：去掉冗余的引用，以DTO方式传入
        MDService.SaveBEComponentAsync(component as BEComponent)
          .then((response: boolean) => {
            const beComponent = component as BEComponent;
            beComponent.persistenceStatus = EnumPersistenceStatus.None;
            deleteDesignIds.push(...this.handlePersistentStatus(beComponent.comments));
            deleteDesignIds.push(...this.handlePersistentStatus(beComponent.entities));
            beComponent.entities.forEach(entity => {
              deleteDesignIds.push(...this.handlePersistentStatus(entity.attributes));
              deleteDesignIds.push(...this.handlePersistentStatus(entity.methods));
              entity.methods.forEach((method) => {
                deleteDesignIds.push(...this.handlePersistentStatus(method.parameters));
              });
            });
            deleteDesignIds.push(...this.handlePersistentStatus(beComponent.interfaces));
            beComponent.interfaces.forEach(inter => {
              deleteDesignIds.push(...this.handlePersistentStatus(inter.attributes));
              deleteDesignIds.push(...this.handlePersistentStatus(inter.methods));
              inter.methods.forEach((method) => {
                deleteDesignIds.push(...this.handlePersistentStatus(method.parameters));
              });
            });
            deleteDesignIds.push(...this.handlePersistentStatus(beComponent.enums));
            beComponent.enums.forEach((bEEnum) => {
              deleteDesignIds.push(...this.handlePersistentStatus(bEEnum.enumItems));
            });
            deleteDesignIds.push(...this.handlePersistentStatus(beComponent.services));
            beComponent.services.forEach((service) => {
              deleteDesignIds.push(...this.handlePersistentStatus(service.serviceActions));
            });
            deleteDesignIds.push(...this.handlePersistentStatus(beComponent.externalServices));
            beComponent.externalServices.forEach((externalService) => {
              deleteDesignIds.push(...this.handlePersistentStatus(externalService.serviceActions));
            });
            deleteDesignIds.push(...this.handlePersistentStatus(beComponent.businessLogics));
            beComponent.businessLogics.forEach((businessLogic) => {
              deleteDesignIds.push(...this.handlePersistentStatus(businessLogic.parameters));
            });
            deleteDesignIds.push(...this.handlePersistentStatus(beComponent.dTOes));
            beComponent.dTOes.forEach((dTO) => {
              deleteDesignIds.push(...this.handlePersistentStatus(dTO.attributes));
            });
            deleteDesignIds.push(...this.handlePersistentStatus(beComponent.valueObjects));
            beComponent.valueObjects.forEach((valueObject) => {
              deleteDesignIds.push(...this.handlePersistentStatus(valueObject.attributes));
              deleteDesignIds.push(...this.handlePersistentStatus(valueObject.methods));
              valueObject.methods.forEach((method) => {
                deleteDesignIds.push(...this.handlePersistentStatus(method.parameters));
              });
            });
            deleteDesignIds.push(...this.handlePersistentStatus(beComponent.constants));
            beComponent.constants.forEach((constant) => {
              deleteDesignIds.push(...this.handlePersistentStatus(constant.items));
            });
            deleteDesignIds.push(...this.handlePersistentStatus(beComponent.referenceEntities));
            deleteDesignIds.push(...this.handlePersistentStatus(beComponent.distributedTransactions));
            beComponent.distributedTransactions.forEach((distributedTransaction) => {
              deleteDesignIds.push(...this.handlePersistentStatus(distributedTransaction.attributes));
            });
            deleteDesignIds.push(...this.handlePersistentStatus(beComponent.entityGenerations));
            deleteDesignIds.push(...this.handlePersistentStatus(beComponent.interfaceGenerations));
            deleteDesignIds.push(...this.handlePersistentStatus(beComponent.implements));
            deleteDesignIds.push(...this.handlePersistentStatus(beComponent.associations));
            deleteDesignIds.push(...this.handlePersistentStatus(beComponent.dependencyAssociations));
            deleteDesignIds.push(...this.handlePersistentStatus(beComponent.compositions));
            deleteDesignIds.push(...this.handlePersistentStatus(beComponent.aggregations));
            deleteDesignIds.push(...this.handlePersistentStatus(beComponent.crossAssociations));
            resolve(response);
          })
          .catch(error => {
            // TODO : 格式化错误返回
            reject(error);
          });
      });
    } else if (component.componentType === EnumComponentType.APP) {
      return new Promise((resolve, reject) => {
        MDService.SaveAPPComponentAsync(component as APPComponent)
          .then((response: boolean) => {
            const appComponent = component as APPComponent;
            appComponent.persistenceStatus = EnumPersistenceStatus.None;
            deleteDesignIds.push(...this.handlePersistentStatus(appComponent.comments));
            deleteDesignIds.push(...this.handlePersistentStatus(appComponent.menuSets));
            appComponent.menuSets.forEach(menuSet => {
              deleteDesignIds.push(...this.handlePersistentStatus(menuSet.menuItems));
            });
            deleteDesignIds.push(...this.handlePersistentStatus(appComponent.configGroups));
            appComponent.configGroups.forEach(configGroup => {
              deleteDesignIds.push(...this.handlePersistentStatus(configGroup.configItems));
            });
            deleteDesignIds.push(...this.handlePersistentStatus(appComponent.menuContains));
            resolve(response);
          })
          .catch(error => {
            // TODO : 格式化错误返回
            reject(error);
          });
      });
    } else if (component.componentType === EnumComponentType.Product) {
      return new Promise((resolve, reject) => {
        BaseService.SaveProductComponentAsync(component as ProductComponent)
          .then((response: boolean) => {
            const productComponent = component as ProductComponent;
            productComponent.persistenceStatus = EnumPersistenceStatus.None;
            deleteDesignIds.push(...this.handlePersistentStatus(productComponent.comments));
            deleteDesignIds.push(...this.handlePersistentStatus(productComponent.productAPPs));
            resolve(response);
          })
          .catch(error => {
            // TODO : 格式化错误返回
            reject(error);
          });
      });
    } else if (component.componentType === EnumComponentType.UIModel) {
      return new Promise((resolve, reject) => {
        MDService.SaveUIModelComponentAsync(component as UIModelComponent)
          .then((response: boolean) => {
            const uiModel = component as UIModelComponent;
            uiModel.persistenceStatus = EnumPersistenceStatus.None;
            deleteDesignIds.push(...this.handlePersistentStatus(uiModel.viewObjects));
            uiModel.viewObjects.forEach(viewObject => {
              deleteDesignIds.push(...this.handlePersistentStatus(viewObject.attributes));
              deleteDesignIds.push(...this.handlePersistentStatus(viewObject.actions));
            });
            deleteDesignIds.push(...this.handlePersistentStatus(uiModel.pageViews));
            deleteDesignIds.push(...this.handlePersistentStatus(uiModel.pageGroups));
            uiModel.pageGroups.forEach(pageGroup => {
              deleteDesignIds.push(...this.handlePersistentStatus(pageGroup.pages));
            });
            deleteDesignIds.push(...this.handlePersistentStatus(uiModel.views));
            resolve(response);
          })
          .catch(error => {
            // TODO : 格式化错误返回
            reject(error);
          });
      });
    }
    return new Promise((resolve) => {
      resolve(false);
    });
  }

  /** 将组件构造成树 */
  static buildComponentTree(component: BaseComponent): Array<TreeNode<BaseElement>> {
    const trees = new Array<TreeNode<BaseElement>>();
    if (component && component !== null) {
      if (component instanceof BEComponent) {
        component.entities.forEach((item: BEEntity) => {
          const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, item.attributes.length + item.methods.length === 0, item);
          item.attributes.forEach(attribute => {
            itemNode.addChild(new TreeNode<BaseElement>(attribute.designId, `${attribute.name}(${attribute.displayName})`, attribute.name, true, attribute));
          });
          item.methods.forEach(method => {
            const methodNode = new TreeNode<BaseElement>(method.designId, `${method.name}(${method.displayName})`, method.name, method.parameters.length === 0, method);
            method.parameters.forEach(parameter => {
              methodNode.addChild(new TreeNode<BaseElement>(parameter.designId, `${parameter.name}(${parameter.displayName})`, parameter.name, true, parameter));
            });
            itemNode.addChild(methodNode);
          });
          trees.push(itemNode);
        });
        component.services.forEach((item: BEService) => {
          const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, item.serviceActions.length === 0, item);
          item.serviceActions.forEach(serviceAction => {
            itemNode.addChild(new TreeNode<BaseElement>(serviceAction.designId, `${serviceAction.name}(${serviceAction.displayName})`, serviceAction.name, true, serviceAction));
          });
          trees.push(itemNode);
        });
        component.enums.forEach((item: BEEnum) => {
          const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, item.enumItems.length === 0, item);
          item.enumItems.forEach(enumItem => {
            itemNode.addChild(new TreeNode<BaseElement>(enumItem.designId, `${enumItem.name}(${enumItem.displayName})`, enumItem.name, true, enumItem));
          });
          trees.push(itemNode);
        });
        component.constants.forEach((item: BEConstant) => {
          const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, item.items.length === 0, item);
          item.items.forEach(constantItem => {
            itemNode.addChild(new TreeNode<BaseElement>(constantItem.designId, `${constantItem.name}(${constantItem.displayName})`, constantItem.name, true, constantItem));
          });
          trees.push(itemNode);
        });
        component.comments.forEach((item: BEComment) => {
          const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, true, item);
          trees.push(itemNode);
        });
        component.externalServices.forEach((item: BEExternalService) => {
          const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, item.parameters.length === 0, item);
          item.parameters.forEach(parameter => {
            itemNode.addChild(new TreeNode<BaseElement>(parameter.designId, `${parameter.name}(${parameter.displayName})`, parameter.name, true, parameter));
          });
          trees.push(itemNode);
        });
        component.interfaces.forEach((item: BEInterface) => {
          const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, item.attributes.length + item.methods.length === 0, item);
          item.attributes.forEach(attribute => {
            itemNode.addChild(new TreeNode<BaseElement>(attribute.designId, `${attribute.name}(${attribute.displayName})`, attribute.name, true, attribute));
          });
          item.methods.forEach(method => {
            const methodNode = new TreeNode<BaseElement>(method.designId, `${method.name}(${method.displayName})`, method.name, method.parameters.length === 0, method);
            method.parameters.forEach(parameter => {
              methodNode.addChild(new TreeNode<BaseElement>(parameter.designId, `${parameter.name}(${parameter.displayName})`, parameter.name, true, parameter));
            });
            itemNode.addChild(methodNode);
          });
          trees.push(itemNode);
        });
        component.valueObjects.forEach((item: BEValueObject) => {
          const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, item.attributes.length === 0, item);
          item.attributes.forEach(attribute => {
            itemNode.addChild(new TreeNode<BaseElement>(attribute.designId, `${attribute.name}(${attribute.displayName})`, attribute.name, true, attribute));
          });
          item.methods.forEach(method => {
            const methodNode = new TreeNode<BaseElement>(method.designId, `${method.name}(${method.displayName})`, method.name, method.parameters.length === 0, method);
            method.parameters.forEach(parameter => {
              methodNode.addChild(new TreeNode<BaseElement>(parameter.designId, `${parameter.name}(${parameter.displayName})`, parameter.name, true, parameter));
            });
            itemNode.addChild(methodNode);
          });
          trees.push(itemNode);
        });
        component.dTOes.forEach((item: BEDTO) => {
          const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, item.attributes.length === 0, item);
          item.attributes.forEach(attribute => {
            itemNode.addChild(new TreeNode<BaseElement>(attribute.designId, `${attribute.name}(${attribute.displayName})`, attribute.name, true, attribute));
          });
          trees.push(itemNode);
        });
        component.businessLogics.forEach((item: BEBusinessLogic) => {
          const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, item.parameters.length === 0, item);
          item.parameters.forEach(parameter => {
            itemNode.addChild(new TreeNode<BaseElement>(parameter.designId, `${parameter.name}(${parameter.displayName})`, parameter.name, true, parameter));
          });
          trees.push(itemNode);
        });
      } else if (component instanceof APPComponent) {
        component.comments.forEach((item: APPComment) => {
          const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, true, item);
          trees.push(itemNode);
        });
        component.menuSets.forEach((item: MenuSet) => {
          const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, item.menuItems.length === 0, item);
          item.menuItems.forEach((menuItem: MenuItem) => {
            itemNode.addChild(new TreeNode<BaseElement>(menuItem.designId, `${menuItem.name}(${menuItem.displayName})`, menuItem.name, true, menuItem));
          });
          trees.push(itemNode);
        });
        component.configGroups.forEach((item: ConfigGroup) => {
          const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, item.configItems.length === 0, item);
          item.configItems.forEach((configItem: ConfigItem) => {
            itemNode.addChild(new TreeNode<BaseElement>(configItem.designId, `${configItem.name}(${configItem.displayName})`, configItem.name, true, configItem));
          });
          trees.push(itemNode);
        });
      } else if (component instanceof ProductComponent) {
        component.comments.forEach((item: ProductComment) => {
          const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, true, item);
          trees.push(itemNode);
        });
        component.productAPPs.forEach((item: ProductAPP) => {
          const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, true, item);
          trees.push(itemNode);
        });
      } else if (component instanceof UIModelComponent) {
        component.pageGroups.forEach((item: UIPageGroup) => {
          const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, item.pages.length === 0, item);
          item.pages.forEach((page: UIPage) => {
            itemNode.addChild(new TreeNode<BaseElement>(page.designId, `${page.name}(${page.displayName})`, page.name, true, page));
          });
          trees.push(itemNode);
        });
        component.views.forEach((item: UIView) => {
          const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, true, item);
          trees.push(itemNode);
        });
        component.viewObjects.forEach((item: ViewObject) => {
          const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, (item.attributes.length + item.actions.length) === 0, item);
          item.attributes.forEach((attribute: EVOAttribute) => {
            itemNode.addChild(new TreeNode<BaseElement>(attribute.designId, `${attribute.name}(${attribute.displayName})`, attribute.name, true, attribute));
          });
          item.actions.forEach((action: EVOAction) => {
            itemNode.addChild(new TreeNode<BaseElement>(action.designId, `${action.name}(${action.displayName})`, action.name, true, action));
          });
          trees.push(itemNode);
        });
      }
    }
    return trees;
  }

  /**
   * 获取数据类型的树节点
   * @param component 组件
   * @param beType 实体组件的类型，仅支持实体组件筛选，使用EnumBEType的二进制值之和，0代表所有
   * @returns 数据类型树节点
   */
  static buildDataTypeTree(component: BaseComponent, beType: number): Array<TreeNode<BaseElement>> {
    const trees = new Array<TreeNode<BaseElement>>();
    if (component && component !== null) {
      if (component instanceof BEComponent) {
        if ((beType === 0 || (beType & EnumBEType.BEEnum) > 0) && component.enums.length > 0) {
          const typeNode = new TreeNode<BaseElement>(component.designId + '_enum', '枚举', '', false, null);
          trees.push(typeNode);
          component.enums.forEach((item: BEEnum) => {
            const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, true, item);
            typeNode.addChild(itemNode);
          });
        }
        if ((beType === 0 || (beType & EnumBEType.BEInterface) > 0) && component.interfaces.length > 0) {
          const typeNode = new TreeNode<BaseElement>(component.designId + '_interface', '接口', '', false, null);
          trees.push(typeNode);
          component.interfaces.forEach((item: BEInterface) => {
            const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, true, item);
            typeNode.addChild(itemNode);
          });
        }
        if ((beType === 0 || (beType & EnumBEType.BEEntity) > 0) && component.entities.length > 0) {
          const typeNode = new TreeNode<BaseElement>(component.designId + '_entity', '实体', '', false, null);
          trees.push(typeNode);
          component.entities.forEach((item: BEEntity) => {
            const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, true, item);
            typeNode.addChild(itemNode);
          });
        }
        if ((beType === 0 || (beType & EnumBEType.BEDTO) > 0) && component.dTOes.length > 0) {
          const typeNode = new TreeNode<BaseElement>(component.designId + '_dto', 'DTO', '', false, null);
          trees.push(typeNode);
          component.dTOes.forEach((item: BEDTO) => {
            const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, true, item);
            typeNode.addChild(itemNode);
          });
        }
        if ((beType === 0 || (beType & EnumBEType.BEValueObject) > 0) && component.valueObjects.length > 0) {
          const typeNode = new TreeNode<BaseElement>(component.designId + '_vo', '值对象', '', false, null);
          trees.push(typeNode);
          component.valueObjects.forEach((item: BEValueObject) => {
            const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, true, item);
            typeNode.addChild(itemNode);
          });
        }
        if ((beType === 0 || (beType & EnumBEType.BEBusinessLogic) > 0) && component.businessLogics.length > 0) {
          const typeNode = new TreeNode<BaseElement>(component.designId + '_bl', '商业逻辑', '', false, null);
          trees.push(typeNode);
          component.businessLogics.forEach((item: BEBusinessLogic) => {
            const itemNode = new TreeNode<BaseElement>(item.designId, `${item.name}(${item.displayName})`, item.name, true, item);
            typeNode.addChild(itemNode);
          });
        }
      }
    }
    return trees;
  }

  /**
   * 获取页面的树节点
   * @param component 组件
   * @returns 数据类型树节点
   */
  static buildUIPageTree(component: BaseComponent): Array<TreeNode<BaseElement>> {
    const trees = new Array<TreeNode<BaseElement>>();
    if (component && component !== null) {
      if (component instanceof UIModelComponent) {
        if (component.pageGroups.length > 0) {
          component.pageGroups.forEach((pageGroup: UIPageGroup) => {
            const pageGroupNode = new TreeNode<BaseElement>(pageGroup.designId, `${pageGroup.name}(${pageGroup.displayName})`, pageGroup.name, false, pageGroup);
            pageGroup.pages.forEach(page => {
              const pageNode = new TreeNode<BaseElement>(page.designId, `${page.name}(${page.displayName})`, page.name, true, page);
              pageGroupNode.addChild(pageNode);
            });
            trees.push(pageGroupNode);
          });
        }
      }
    }
    return trees;
  }

  /**
   * 从源数组将元数据信息复制到目标数组：
   * 1. 如果源和目标都有相应元素，则进行属性复制
   * 2. 如果源有，目标没有，则在目标中添加（此规则不支持）
   * 3. 当isRemoveNotExist为true，如果源没有，目标有，则从目标中删除，删除分为两种方式：
   * 3.1 如果修改状态为Create，则从目标数组删除
   * 3.2 如果修改状态不为Create，则将目标数组内的元素修改状态设置为Delete
   * @param source 源数组
   * @param target 目标数组
   * @param isRemoveNotExist 是否在目标数组中删除源数组中没有的元素
   */
  static copyMDArray<T extends BaseElement>(source: Array<BaseElement>, target: Array<BaseElement>, isRemoveNotExist: boolean, C: { new (): T }) {
    const removed = new Array<BaseElement>();
    const handleIds = new Array<string>();
    source.forEach(item => {
      const element = target.find(attrItem => attrItem.designId === item.designId);
      if (element) {
        element.copyFrom(item, true);
      } else {
        const newElement = new C();
        target.push(newElement);
        newElement.copyFrom(item, true);
      }
      handleIds.push(item.designId);
    });
    target.forEach(item => {
      if (handleIds.indexOf(item.designId) < 0) {
        if (isRemoveNotExist) {
          if (item.persistenceStatus === EnumPersistenceStatus.Create) {
            removed.push(item);
          } else {
            item.persistenceStatus = EnumPersistenceStatus.Delete;
          }
        }
      }
    });
    removed.forEach(item => target.splice(target.indexOf(item), 1));
  }

  /** 设置元数据的创建信息，用于克隆以后 */
  static setCreateInfo(element: BaseElement | ShapeElement) {
    element.id = UniqueKeyManager.instance.getUniqueKey();
    element.designId = GuidHelper.getGuid();
    element.persistenceStatus = EnumPersistenceStatus.Create;
    element.createdOn = new Date();
    element.modifiedOn = new Date();
    element.createdBy = IDEContext.instance.curAccountInfo.accountId;
    element.owner = IDEContext.instance.curUser.tenancy_ID;
    return element;
  }

  /**
   * 对元数据列表进行排序，并重新设置Sequence的值
   * Sequence根据最新排序后的结果进行递增赋值，如果顺序有变化则更新
   * 逻辑删除的元素，不计入排序
   * @param elements 要排序的元数据列表
   * @param onlySetSequence true：仅仅设置Sequence的值，而不需要进行排序，false：代表先排序后设置值
   */
  static setElementListSequence(elements: Array<BaseElement>, onlySetSequence: boolean): Array<BaseElement> {
    if (!onlySetSequence) {
      elements.sort((pre: BaseElement, after: BaseElement) => pre.sequence - after.sequence);
    }
    let index = 0;
    elements.forEach(element => {
      if (element.persistenceStatus !== EnumPersistenceStatus.Delete && element.persistenceStatus !== EnumPersistenceStatus.Remove) {
        if (element.sequence !== index) {
          element.sequence = index;
          if (element.persistenceStatus !== EnumPersistenceStatus.Create) {
            element.persistenceStatus = EnumPersistenceStatus.Update;
          }
        }
        index++;
      }
    });
    return elements;
  }

  /**
   * 处理元数据的属性框，根据不同的元数据定义属性中的可浏览和可编辑
   * @param context 属性框的上下文（存放的元元数据）
   * @param element 变更的元数据
   */
  static handleElementProperty(context: PGContext, element: any) {
    context.getRow('status').isBrowsable = false;
    if (element instanceof UIModelComponent) {
      context.getRow('alias').isBrowsable = false;
    } else if (element instanceof ProductComponent) {
      context.getRow('alias').isBrowsable = false;
    } else if (element instanceof DTAttribute) {
      context.getRow('isReadOnly').isBrowsable = false;
      context.getRow('isTitle').isBrowsable = false;
    }
  }

  /**
   * 处理属性变更，用于扩展实体的属性变更联动
   * @param element 变更的元数据
   * @param name 属性名称
   * @param newValue 变更后的值
   * @param newElement 变更后的元数据，优先判定，如果为空才使用newValue
   */
  static handlePropertyChange(element: any, name: string, newValue: string, newElement: BaseElement) {
    if (newElement !== null) {
      element[name] = newElement;
      if (element instanceof BEServiceAction && (newElement instanceof BEBusinessLogic || newElement instanceof BEExternalService)) {
        element.name = newElement.name;
        element.displayName = newElement.displayName;
        element.description = newElement.description;
        if (newElement instanceof BEBusinessLogic) {
          element.serviceActionType = EnumServiceActionType.BusinessLogic;
        } else if (newElement instanceof BEExternalService) {
          element.serviceActionType = EnumServiceActionType.API;
        }
      } else if (element instanceof ProductAPP) {
        if (name === 'aPP') {
          element.name = 'Product' + newElement.name;
          element.displayName = newElement.displayName;
          element.description = newElement.description;
        }
      } else if (element instanceof MenuItem) {
        if (name === 'page' && element.name === 'Menu') {
          element.name = 'Menu' + newElement.name;
          element.displayName = newElement.displayName;
          element.description = newElement.displayName;
          if (element.displayName.endsWith('页')) {
            element.displayName = element.displayName.substring(0, element.displayName.length - 1);
          }
        }
      }
    } else {
      element[name] = newValue;
      if (element instanceof BaseAttribute || element instanceof MDParameter) {
        if (name === 'referenceType') {
          if (newValue !== '') {
            // todo : 这里要判断，当前属性或参数与值是否是同一个应用，不是的话要改为UniqueKey
            if (element.dataType !== EnumDataType.Reference && element.dataType !== EnumDataType.UniqueKey) {
              element.dataType = EnumDataType.Reference;
            }
          } else {
            element.dataType = EnumDataType.String;
          }
        }
        if (element instanceof BEAttribute) {
          if (name === 'isUnique') {
            if (newValue) {
              element.isNullable = false;
            }
          }
        }
      } else if (element instanceof BEBusinessLogic || element instanceof BEExternalService || element instanceof BEDistributedTransaction || element instanceof BaseMethod) {
        if (name === 'returnReferenceType') {
          if (newValue !== '') {
            // todo : 这里要判断，当前属性或参数与值是否是同一个应用，不是的话要改为UniqueKey
            if (element.returnDataType !== EnumDataType.Reference && element.returnDataType !== EnumDataType.UniqueKey) {
              element.returnDataType = EnumDataType.Reference;
            }
          } else {
            element.returnDataType = EnumDataType.String;
          }
        }
      }
    }
    element.modify();
  }

  /**
   * 处理属性变更，用于扩展实体的属性变更联动
   * @param context 属性框的上下文（存放的元元数据）
   * @param element 变更的元数据
   * @param name 属性名称
   * @param newValue 变更后的值
   */
  static handlePropertyMetaChange(context: PGContext, element: any, name: string, newValue: any) {
    if (element instanceof BaseElement) {
      if (name === 'displayName' && (!element.description || element.description === '' || element.description === null)) {
        element.description = newValue;
      }
    }
    if (element instanceof BEEntity) {
      if (name === 'entityStructureType') {
        switch (newValue) {
          case EnumEntityStructureType.TreeEntity:
            context.getRow('treeEntityLevel').isBrowsable = true;
            break;
          case EnumEntityStructureType.SingleEntity:
          default:
            context.getRow('treeEntityLevel').isBrowsable = false;
            break;
        }
      }
    } else if (element instanceof CompleteAttribute) {
      const row = context.getRow(name);
      if (row !== null) {
        if (name === 'dataType') {
          context.getRow('length').isBrowsable = true;
          context.getRow('precision').isBrowsable = true;
          context.getRow('scale').isBrowsable = true;
          context.getRow('isFixLength').isBrowsable = false;
          context.getRow('isUnicode').isBrowsable = false;
          context.getRow('isNullable').isEditable = true;
          context.getRow('trueLabel').isBrowsable = false;
          context.getRow('falseLabel').isBrowsable = false;
          context.getRow('referenceType').isBrowsable = false;
          context.getRow('isUnicode').isBrowsable = false;
          switch (newValue) {
            case EnumDataType.Bool:
              context.getRow('length').isBrowsable = false;
              context.getRow('precision').isBrowsable = false;
              context.getRow('scale').isBrowsable = false;
              element.isNullable = false;
              context.getRow('isNullable').isEditable = false;
              context.getRow('trueLabel').isBrowsable = true;
              context.getRow('falseLabel').isBrowsable = true;
              break;
            case EnumDataType.Date:
            case EnumDataType.DateTime:
            case EnumDataType.Time:
              context.getRow('length').isBrowsable = false;
              context.getRow('scale').isBrowsable = false;
              break;
            case EnumDataType.Double:
            case EnumDataType.Float:
            case EnumDataType.Money:
              context.getRow('length').isBrowsable = false;
              element.isNullable = false;
              context.getRow('isNullable').isEditable = false;
              break;
            case EnumDataType.Guid:
              context.getRow('length').isBrowsable = false;
              context.getRow('precision').isBrowsable = false;
              context.getRow('scale').isBrowsable = false;
              break;
            case EnumDataType.Int:
            case EnumDataType.Long:
            case EnumDataType.Short:
              context.getRow('length').isBrowsable = false;
              context.getRow('precision').isBrowsable = false;
              context.getRow('scale').isBrowsable = false;
              element.isNullable = false;
              context.getRow('isNullable').isEditable = false;
              break;
            case EnumDataType.String:
            case EnumDataType.Richtext:
            case EnumDataType.Text:
              context.getRow('precision').isBrowsable = false;
              context.getRow('scale').isBrowsable = false;
              context.getRow('isFixLength').isBrowsable = true;
              context.getRow('isUnicode').isBrowsable = true;
              break;
            case EnumDataType.UniqueKey:
              element.length = 19;
              element.isUnicode = false;
              element.isFixLength = true;
              context.getRow('length').isBrowsable = false;
              context.getRow('precision').isBrowsable = false;
              context.getRow('scale').isBrowsable = false;
              context.getRow('referenceType').isBrowsable = true;
              break;
            case EnumDataType.Reference:
              context.getRow('length').isBrowsable = false;
              context.getRow('precision').isBrowsable = false;
              context.getRow('scale').isBrowsable = false;
              context.getRow('referenceType').isBrowsable = true;
              break;
            default:
              break;
          }
        } else if (name === 'isValidate') {
          if (newValue) {
            context.getRow('validateExpress').isBrowsable = true;
            context.getRow('errorMessage').isBrowsable = true;
            context.getRow('maxValue').isBrowsable = true;
            context.getRow('minValue').isBrowsable = true;
          } else {
            context.getRow('validateExpress').isBrowsable = false;
            context.getRow('errorMessage').isBrowsable = false;
            context.getRow('maxValue').isBrowsable = false;
            context.getRow('minValue').isBrowsable = false;
          }
        }
      }
    } else if (element instanceof UIPage) {
      if (name === 'name') {
        element.filename = newValue;
      }
    } else if (element instanceof MDParameter) {
      if (name === 'dataType') {
        context.getRow('referenceType').isBrowsable = false;
        switch (newValue) {
          case EnumDataType.Reference:
          case EnumDataType.UniqueKey:
            context.getRow('referenceType').isBrowsable = true;
            break;
          default:
            break;
        }
      }
      if (name === 'isValidate') {
        if (newValue) {
          context.getRow('validateExpress').isBrowsable = true;
          context.getRow('errorMessage').isBrowsable = true;
          context.getRow('maxValue').isBrowsable = true;
          context.getRow('minValue').isBrowsable = true;
        } else {
          context.getRow('validateExpress').isBrowsable = false;
          context.getRow('errorMessage').isBrowsable = false;
          context.getRow('maxValue').isBrowsable = false;
          context.getRow('minValue').isBrowsable = false;
        }
      }
    } else if (element instanceof BEBusinessLogic || element instanceof BEExternalService) {
      if (name === 'returnDataType') {
        context.getRow('returnReferenceType').isBrowsable = false;
        switch (newValue) {
          case EnumDataType.Reference:
          case EnumDataType.UniqueKey:
            context.getRow('returnReferenceType').isBrowsable = true;
            break;
          default:
            break;
        }
      }
    }
    if (element instanceof BEAttribute) {
      const row = context.getRow(name);
      if (row !== null) {
        if (name === 'dataType') {
          context.getRow('isUploadImage').isBrowsable = false;
          context.getRow('isUploadFile').isBrowsable = false;
          context.getRow('isPercent').isBrowsable = false;
          switch (newValue) {
            case EnumDataType.String:
            case EnumDataType.Text:
              context.getRow('isUploadImage').isBrowsable = true;
              context.getRow('isUploadFile').isBrowsable = true;
              break;
            case EnumDataType.Double:
            case EnumDataType.Float:
            case EnumDataType.Money:
              context.getRow('isPercent').isBrowsable = true;
              break;
            default:break;
          }
        } else if (name === 'isCalculate') {
          if (newValue) {
            context.getRow('calculateExpress').isBrowsable = true;
          } else {
            context.getRow('calculateExpress').isBrowsable = false;
          }
        }
      }
    }
  }

  /**
   * 处理保存后的持久化状态
   * 如果是Delete、Remove则从集合删除
   * 否则改为None
   * @param elements 要处理的元素集合
   * @returns 删除的元素DesignID
   */
  static handlePersistentStatus(elements: Array<BaseElement> | Array<ShapeElement>): Array<string> {
    const deleteDesignIds = new Array<string>();
    elements.forEach((element: BaseElement | ShapeElement) => {
      if (element.persistenceStatus === EnumPersistenceStatus.Delete || element.persistenceStatus === EnumPersistenceStatus.Remove) {
        deleteDesignIds.push(element.designId);
      } else {
        element.persistenceStatus = EnumPersistenceStatus.None;
      }
    });
    deleteDesignIds.forEach(deleteId => {
      elements.splice(elements.findIndex((item: BaseElement | ShapeElement) => item.designId === deleteId), 1);
    });
    return deleteDesignIds;
  }
}
